import React from "react";
import { IconProps } from "./IconProps";

const StudentIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.2375 7.28875L16.2375 3.28875C16.0833 3.23729 15.9167 3.23729 15.7625 3.28875L3.7625 7.28875C3.61327 7.33857 3.48349 7.43406 3.39151 7.5617C3.29954 7.68934 3.25003 7.84267 3.25 8V18C3.25 18.1989 3.32902 18.3897 3.46967 18.5303C3.61032 18.671 3.80109 18.75 4 18.75C4.19891 18.75 4.38968 18.671 4.53033 18.5303C4.67098 18.3897 4.75 18.1989 4.75 18V9.04L9.585 10.6525C8.97528 11.5536 8.56212 12.5729 8.37239 13.6442C8.18266 14.7155 8.22062 15.8148 8.4838 16.8704C8.74698 17.9261 9.22948 18.9145 9.8999 19.7714C10.5703 20.6282 11.4136 21.3343 12.375 21.8438C9.96875 22.66 7.875 24.2925 6.375 26.5938C6.28878 26.7589 6.2671 26.9502 6.3142 27.1305C6.36129 27.3107 6.47379 27.467 6.62977 27.5688C6.78576 27.6707 6.97407 27.7109 7.15804 27.6815C7.34201 27.6521 7.50847 27.5554 7.625 27.41C9.55875 24.4487 12.61 22.75 16 22.75C19.39 22.75 22.4412 24.4487 24.375 27.41C24.4908 27.5584 24.6582 27.6579 24.844 27.6886C25.0297 27.7193 25.2203 27.679 25.3777 27.5757C25.5351 27.4725 25.6479 27.3138 25.6938 27.1311C25.7396 26.9485 25.715 26.7554 25.625 26.59C24.125 24.2925 22.0338 22.66 19.625 21.84C20.5858 21.33 21.4286 20.6235 22.0984 19.7664C22.7682 18.9093 23.25 17.9208 23.5126 16.8652C23.7752 15.8096 23.8126 14.7105 23.6224 13.6395C23.4322 12.5684 23.0187 11.5494 22.4088 10.6488L28.2375 8.71125C28.3866 8.66135 28.5163 8.56583 28.6082 8.4382C28.7001 8.31056 28.7495 8.15727 28.7495 8C28.7495 7.84273 28.7001 7.68944 28.6082 7.5618C28.5163 7.43417 28.3866 7.33865 28.2375 7.28875ZM22.25 15C22.2504 15.9959 22.0129 16.9775 21.5571 17.863C21.1013 18.7485 20.4406 19.5123 19.6298 20.0907C18.8191 20.6691 17.8819 21.0454 16.8962 21.1882C15.9106 21.331 14.9051 21.2362 13.9636 20.9117C13.022 20.5872 12.1716 20.0424 11.4833 19.3227C10.7949 18.6029 10.2885 17.7291 10.0063 16.7741C9.72401 15.819 9.67408 14.8103 9.86063 13.832C10.0472 12.8537 10.4648 11.9342 11.0787 11.15L15.7625 12.7113C15.9167 12.7627 16.0833 12.7627 16.2375 12.7113L20.9212 11.15C21.7835 12.2479 22.2515 13.6039 22.25 15ZM16 11.21L6.375 8L16 4.79L25.625 8L16 11.21Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default StudentIcon;
